import * as moment from 'moment';

export interface IBuyTicketsSettings {
    loadWrappingMonthDates: boolean;
    saveHistory: boolean;
    monthsOnCalendar: moment.Moment[];
    desktopToMobileTransitionWidth: string;
    scrollToTopAppearanceOffset: number;
    filtersAlwaysModal: boolean;
}

const calendarEntry = document.getElementById("buytickets-entry-js");

export const defaultCalendarSettings: IBuyTicketsSettings = {
    //Update loadWrappingMonthDates to true after any Calendar upgrade
    loadWrappingMonthDates: false,
    saveHistory: false,
    monthsOnCalendar: [],
    desktopToMobileTransitionWidth: calendarEntry && calendarEntry.getAttribute("data-calendar-breakpoint") ? calendarEntry.getAttribute("data-calendar-breakpoint") : "48em",
    scrollToTopAppearanceOffset: parseInt(calendarEntry && calendarEntry.getAttribute("data-scroll-to-top-offset") ? calendarEntry.getAttribute("data-scroll-to-top-offset") : "500"),
    filtersAlwaysModal: calendarEntry && Boolean(calendarEntry.getAttribute("data-filter-always-modal")) ? Boolean(calendarEntry.getAttribute("data-filter-always-modal")) : false
}